<template>
<div>
	<div class="row">
		<div class="col-12 col-lg-3">
			<h3>{{ $t('date-picker.choose') }}</h3>
		</div>
		<div class="col-12 col-lg-9">
			<span class="m-2" v-for="(select_year,index) in yearRange" :key="index">
				<button @click="chooseYear(select_year)" type="button" class="btn btn-outline-secondary btn-sm mb-2" :class="{active: selected_year==select_year}">{{ select_year }}</button>
			</span>
		</div>
	</div>
	<div class="row mt-4" v-if="optional_months">
		<div class="col-12 col-lg-3">
			<h3>{{ $t('date-picker.choose-month') }}</h3>
		</div>
		<div class="col-12 col-lg-9">
			<span class="m-2" v-for="(select_month,index) in monthRange" :key="index">
				<button @click="chooseMonth(index)" type="button" class="btn btn-outline-secondary btn-sm mb-2" :class="{active: selected_month===index}" :disabled="!selected_year">{{ $t('date-picker.months.' + select_month) }}</button>
			</span>
		</div>
	</div>
	<div class="row mt-4">
		<div class="col-12 col-lg-3"></div>
		<div class="col-12 col-lg-9">
			<span class="m-2" v-if="selected_year">
				<button @click="chooseYear(false)" type="button" class="btn btn-light btn-sm mb-2">{{ $t('date-picker.clear') }}</button>
			</span>
		</div>
	</div>
</div>
</template>

<script>
export default {
	props: {
    from_date: {
      type: Date,
      required: true,
    },
    to_date: {
      type: Date,
      required: false,
      default: new Date,
    },
    set_year: {
      type: String,
      required: false,
      default: "",
    },
    set_month: {
      type: String,
      required: false,
      default: "",
    },
    optional_months: {
      type: Boolean,
      required: false,
      default: true,
    }
  },

	data() {
		return {
      month_keys: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
      selected_year: null,
      selected_month: null
		}
	},
	created() {
    if (this.set_year) {
      this.selected_year = this.$route.params.year;
      if (this.set_month && this.optional_months) {
        this.selected_month = parseInt(this.$route.params.month) - 1;
      }
    }
	},

	computed: {

		monthRange() {
      let start_idx = 0;
			let end_idx = this.month_keys.length;

			if (this.to_date.getFullYear() == this.selected_year) {
				end_idx = this.to_date.getMonth() + 1;
      }

			if (this.from_date.getFullYear() == this.selected_year) {
				start_idx = this.from_date.getMonth();
      }

			return this.month_keys.slice(start_idx,end_idx);
		},

		yearRange() {
			let max = this.to_date.getFullYear();
      let min = this.from_date.getFullYear();

			var years = [];

			for (var i = min; i <= max; i++) {
				years.push(i);
			}
			return years;
		},
	},

	methods: {
		chooseYear(year) {
			this.$emit('set-year',year);
			this.selected_year = year;
			if (!year) {
				this.chooseMonth(false);
			} else if (!this.optional_months) {
				this.$emit('set-month', null);
			}
		},

		chooseMonth(month) {
			if (month !== false) {
				this.$emit('set-month',month + 1);
			}
			this.selected_month = month;
		},

	},

}
</script>

<style scoped>

</style>
